/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetCompositionsDetailByIdQueryResponse, WebAppGetCompositionsDetailByIdPathParams, WebAppGetCompositionsDetailById401, WebAppGetCompositionsDetailById403 } from "../models/WebAppGetCompositionsDetailById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppGetCompositionsDetailById } from "../axios/webAppGetCompositionsDetailById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppGetCompositionsDetailByIdQueryKey = (id: WebAppGetCompositionsDetailByIdPathParams["id"]) => ["api-v2", { url: '/web-app/v1/compositions/:id', params: {id:id} }] as const

export type WebAppGetCompositionsDetailByIdQueryKey = ReturnType<typeof webAppGetCompositionsDetailByIdQueryKey>

export function webAppGetCompositionsDetailByIdQueryOptions(id: WebAppGetCompositionsDetailByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetCompositionsDetailByIdQueryKey(id)
        return queryOptions<WebAppGetCompositionsDetailByIdQueryResponse, ResponseErrorConfig<WebAppGetCompositionsDetailById401 | WebAppGetCompositionsDetailById403>, WebAppGetCompositionsDetailByIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetCompositionsDetailById(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get one composition by id
 * {@link /web-app/v1/compositions/:id}
 */
export function useWebAppGetCompositionsDetailById<TData = WebAppGetCompositionsDetailByIdQueryResponse, TQueryData = WebAppGetCompositionsDetailByIdQueryResponse, TQueryKey extends QueryKey = WebAppGetCompositionsDetailByIdQueryKey>(id: WebAppGetCompositionsDetailByIdPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<WebAppGetCompositionsDetailByIdQueryResponse, ResponseErrorConfig<WebAppGetCompositionsDetailById401 | WebAppGetCompositionsDetailById403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetCompositionsDetailByIdQueryKey(id)
         

         const query = useQuery({
          ...webAppGetCompositionsDetailByIdQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WebAppGetCompositionsDetailById401 | WebAppGetCompositionsDetailById403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}